import { type ReactElement, useRef } from 'react';
import { roundTo, Tooltip } from '@optimization/ssi-common';
import { NotAvailable } from '../../../NotAvailable';
import styles from './style.module.scss';

const UNIT = '%';

interface StateOfHealthCellProperties {
  readonly stateOfHealthAlert: boolean;
  readonly stateOfHealthRatio?: number;
  readonly isStateOfHealthEstimated?: boolean;
  readonly showTooltip?: boolean;
}

const StateOfHealthCell = ({
  stateOfHealthAlert,
  stateOfHealthRatio,
  isStateOfHealthEstimated,
  showTooltip = true,
}: StateOfHealthCellProperties): ReactElement => {
  const estimatedRef = useRef<HTMLSpanElement>(null);

  if (typeof stateOfHealthRatio !== 'number') {
    return (
      <div className={styles.content} data-testid="state-of-health-cell">
        <NotAvailable />
      </div>
    );
  }

  const formatted = roundTo(stateOfHealthRatio * 100, 0);
  const value = (
    <>
      {isStateOfHealthEstimated ? <span ref={estimatedRef}>* </span> : null}
      {formatted} {UNIT}
    </>
  );

  if (stateOfHealthAlert) {
    return (
      <>
        <div className={styles.content} data-testid="state-of-health-cell">
          <span className="tds-text-warning">{value}</span>
        </div>
        {isStateOfHealthEstimated && showTooltip ? (
          <Tooltip elRef={estimatedRef}>
            <span>Estimated</span>
          </Tooltip>
        ) : null}
      </>
    );
  }

  return (
    <>
      <div className={styles.content} data-testid="state-of-health-cell">
        {isStateOfHealthEstimated ? <span ref={estimatedRef}>* </span> : null}
        {formatted} <span className="tds-text-grey-350">{UNIT}</span>
      </div>
      {isStateOfHealthEstimated && showTooltip ? (
        <Tooltip elRef={estimatedRef}>
          <span>Estimated</span>
        </Tooltip>
      ) : null}
    </>
  );
};

export default StateOfHealthCell;
